import logo from "./logo.svg";
import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import "./App.scss";
import { store, persistor } from "./store";
import { Helmet } from "react-helmet";
import { Provider } from "react-redux";
import RenderRoutes from "./routes";
import { PersistGate } from "redux-persist/integration/react";
import { getVisitorServiceUrl } from "./services/api-constants";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// Slick Carousel CSS ------ Start
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import OlarkHandler from "./components/olark-handler/component";
import ScrollToTop from "./components/scroll-to-top";
import { useTranslation } from "react-i18next";
import useLanguageCode from "./utils/language-code";

function App() {
  const currentEnv = `${process.env.REACT_APP_ENVIRONMENT}`;
  const url = getVisitorServiceUrl("");
  window.$ = $;
  window.jQuery = $;
  // const { i18n } = useTranslation();
  // useEffect(() => {
  //   document.documentElement.setAttribute("lang", i18n.language);
  //   if (i18n.language === "ar") {
  //     document.documentElement.setAttribute("dir", "rtl"); // Set RTL for Arabic
  //   } else {
  //     document.documentElement.setAttribute("dir", "ltr"); // Set LTR for other languages
  //   }
  // }, [i18n.language]);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Helmet>
          <script src={url} type="text/javascript" />
          {/* <script src={ssourl} type="text/javascript" /> */}
        </Helmet>
        <BrowserRouter>
          <RenderRoutes />
          <ToastContainer />
          <OlarkHandler />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
}

export default App;
